import { useEffect, useState } from "react";
import { DEFAULT_PAGE_SIZE } from "../constants/versionHistory.constants";

export function useVersionHistoryPagination(params: { productId: string | undefined; salesUnitId: string | undefined }) {
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSizeState] = useState<number>(DEFAULT_PAGE_SIZE);

  useEffect(() => {
    setPageNumber(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.productId, params.salesUnitId]);

  const setPageSize = (size: number) => {
    setPageSizeState(size);
    setPageNumber(1);
  };

  return { pageNumber, pageSize, setPageNumber, setPageSize };
}
